import React, {Component} from 'react';


import BlogPage from '../BlogPageContainer/BlogPage';
import Footer from '../Footer/Footer';
import axios from 'axios';
import { withRouter } from 'react-router';


class BlogPageContainer extends Component {
  
  state ={blogs:[]}

  componentDidMount(){
    
    const { match } = this.props;
   const blogId=match.params.blogId;
   console.log("pageId" +blogId);

    axios.get('https://api.shopmuthu.com/blog/'+blogId)
    .then( response => {

      console.log(response);
      this.setState({blogs:response.data});
      
    });
  }

  render (){

    let pageContent=null;
    
    //console.log(this.state.products.specification); 
    pageContent= (
          
          <div>   
          
            {this.state.blogs.map( (blog,index) =>{                   
                            
            return  <BlogPage 
              click={() => this.showProductDisplayPage(index)}
              key = {blog.pageName}    
              blog={blog}     
                          
                 
            />
            
          
            })}
            
          </div>
         );      
   
    

    return (
      <React.Fragment>
        
       
            {pageContent}
       
           <Footer/>
            </React.Fragment>
    );
    }
  }

export default withRouter(BlogPageContainer);
